import { AnyAction } from '@reduxjs/toolkit'

import {
  ADD_CUSTOM_APP_INSTANCE_SUCCESS,
  CLEAR_CURRENT_APP,
  DELETE_CUSTOM_APP_INSTANCE_SUCCESS,
  FETCH_CUSTOM_APP_INSTANCE_SUCCESS,
  SET_CURRENT_APP,
  SET_CURRENT_CONNECTOR,
  SET_CURRENT_MICROAPPS,
  UPDATE_CUSTOM_APP_INSTANCE_SUCCESS
} from './actionTypes'

type SpaceCustomAppEditPageState = {
  customApp: any
  customMicroapps: unknown[]
  customConnector: unknown
}

const initialState: SpaceCustomAppEditPageState = {
  customApp: {},
  customMicroapps: [],
  customConnector: {}
}

export default (state = initialState, action: AnyAction): SpaceCustomAppEditPageState => {
  switch (action.type) {
    case ADD_CUSTOM_APP_INSTANCE_SUCCESS: {
      return { ...state, customApp: action.response }
    }
    case FETCH_CUSTOM_APP_INSTANCE_SUCCESS: {
      return {
        ...state,
        customApp: {
          ...state.customApp,
          ...action.response
        }
      }
    }
    case UPDATE_CUSTOM_APP_INSTANCE_SUCCESS: {
      return {
        ...state,
        customApp: {
          ...state.customApp,
          ...action.response
        }
      }
    }
    case DELETE_CUSTOM_APP_INSTANCE_SUCCESS: {
      return {
        ...state,
        customApp: {
          ...action.response
        }
      }
    }
    case SET_CURRENT_APP: {
      return {
        ...state,
        customApp: {
          ...state.customApp,
          ...action.app
        }
      }
    }
    case SET_CURRENT_CONNECTOR: {
      return {
        ...state,
        customConnector: action.connector
      }
    }
    case SET_CURRENT_MICROAPPS: {
      return {
        ...state,
        customMicroapps: [...action.microapps]
      }
    }
    case CLEAR_CURRENT_APP: {
      return { ...initialState }
    }
    default: {
      return state
    }
  }
}
